<template>
  <div class="signin pr">
    <div class="signinBox pa clearfix">
      <div class="swapper fl">
        <el-carousel height="454px" autoplay :interval="10000" indicator-position="none">
          <el-carousel-item v-for="(item,index) in swapper" :key="index">
            <img :src="item" alt="超级简历" srcset="">
          </el-carousel-item>
        </el-carousel>
      </div>

      <div class="signin-content fr bg_fff">

        <div class="heade pr">
          <!-- 切换登录方式 -->
          <div class="togger pa cursor_p">
            <template v-if="signinType==='phone'">
              <img :src="signin_wechat" class="icon " alt="" @click="toggleSigninType('wechat')">
              <img :src="signin_wechat_current" class="icon hover" alt="" @click="toggleSigninType('wechat')">
            </template>
            <template v-else-if="signinType==='wechat'">
              <img :src="signin_phone" class="icon " alt="" @click="toggleSigninType('phone')">
              <img :src="signin_phone_current" class="icon hover" alt="" @click="toggleSigninType('phone')">
            </template>

            <div class="tips f_14 color_9c pa text_center">
              <span v-if="signinType==='phone'" @click="toggleSigninType('wechat')">扫码快速登录</span>
              <span v-else-if="signinType==='wechat'" @click="toggleSigninType('phone')">手机号码登录</span>
            </div>
          </div>
          <!-- 切换登录身份 -->
          <div class="toggerUserType text_center">
            <div class="type cursor_p f_14 transition_2" :class="[account_type!=='hr_account'?'active color_current':'color_9c']" @click="toggerUserType('cv_account')">我是求职者</div>
            <div class="type cursor_p f_14 transition_2" :class="[account_type==='hr_account'?'active color_current':'color_9c']" @click="toggerUserType('hr_account')">我是招聘者</div>
          </div>
        </div>

        <!-- 手机号/邮箱登录样式 -->
        <div class="formBox" v-if="signinType==='phone' || signinType==='email'">

          <template v-if="signinType==='phone'" >
            <div class="formItem flex-c">
              <div class="phoneType f_14 color_40">+86</div>
              <div class="pr flex1">
                <input type="text" class="input f_16 color_40" v-model="phoneData.phone" placeholder="输入手机" maxlength="11" @focus="inputFocus('phone')">
                <div class="errorTips pa color_current f_14" v-if="errorData.phone">{{errorData.phone}}</div>
              </div>
            </div>
            <div class="formItem flex-c">
              <div class="flex1 pr">
                <input type="text" class="input f_16 color_40" v-model="phoneData.code" placeholder="请输入验证码" maxlength="6" @focus="inputFocus('code')" >
                <div class="errorTips pa color_current f_14" v-if="errorData.code">{{errorData.code}}</div>
              </div>
              <div class="getCode cursor_p text_center f_14">
                <span class="color_blue" @click="tencentRobot" v-if="codeData.time === 60">发送验证码</span>
                <span class="color_9c" v-else >{{codeData.time}} 秒后可重发</span>
              </div>
            </div>
          </template>
          <template v-else >
            <div class="formItem flex-c">
              <input type="text" class="input flex1 f_16 color_40" placeholder="请输入邮箱" maxlength="30">
            </div>
            <div class="formItem flex-c">
              <input type="text" class="input flex1 f_16 color_40" placeholder="请输入验证码" maxlength="6">
              <div class="getCode cursor_p text_center f_14">
                <span class="color_blue" @click="tencentRobot" v-if="codeData.time === 60">发送验证码</span>
                <span class="color_9c" v-else >{{codeData.time}} 秒后可重发</span>
              </div>
            </div>
          </template>

          <div class="submitButton cursor_p color_fff text_center bg_current f_16" @click="signin()">登录</div>
        </div>
        <!-- 手机号登录时显示切换别的登录方式 -->
        <div class="clearfix moreText" v-if="signinType==='phone'">
          <!-- <div class="fl f_14 color_9c cursor_p more transition_all" @click="toggleSigninType('other')" v-if="account_type==='cv_account' && !isJbTemps">其它方式登录</div> -->
          <div class="fl f_14 color_60">新用户将为您免费注册账号</div>
          <div class="fr f_14 color_9c cursor_p more" @click="errorMessage">登录遇到问题？</div>
        </div>

        <!-- 微信登录样式 -->
        <div class="wechatSignin" v-if="signinType==='wechat'">
          <!-- <el-popover
            placement="top-start"
            width="400"
            trigger="hover">
            <p>非常抱歉影响您的使用体验，若您现在微信扫码登录登录不上去，可以尝试以下几种方式解决：</p>
            <p>1. 如果您的超级简历账号绑定了手机号，可以尝试使用手机号验证码登录（若您登录上之后发现账号内无您之前的简历信息，则此方法不适用）</p>
            <p>2. 您可以先在微信搜索【<span style="color: #ff6644">超级简历WonderCV</span>】公众号，手动关注公众号后，再扫码登录</p>
            <p>3. 您可以先在手机应用商店下载【<span style="color: #ff6644">超级简历APP</span>】，在APP端授权登录后，进入APP点击【<span style="color: #ff6644">我</span>】-右上角【<span style="color: #ff6644">扫码</span>】按钮，扫描PC端登录二维码登录</p>
            <div slot="reference" class="login-tips">
              <svg t="1703151296743" class="icon" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="16641" width="16" height="16"><path d="M566.6 588.38a54.6 54.6 0 0 1-109.2 0V261.08a54.6 54.6 0 0 1 109.2 0v327.3zM512 795.62a54.6 54.6 0 1 1 0-109.08 54.6 54.6 0 0 1 0 109.08zM512 32a480 480 0 1 0 0 960A480 480 0 0 0 512 32z" p-id="16642" fill="#8a8a8a"></path></svg>
              <span class="tips-text">扫码登录失败解决方式</span>
            </div>
          </el-popover> -->
          <div class="qrCode pr" style="position: relative">
            <img
              v-show="!isImageLoading && account_type === 'hr_account'"
              :src="qrCodeData.url"
              alt=""
              class="qrCodeImg"
              @load="isImageLoading=false"
            />
            <img
              v-show="!isImageLoading && account_type === 'cv_account'"
              :src="microQrCode"
              alt=""
              class="qrCodeImg"
              @load="isImageLoading=false"
            />
            <span class="el-icon-loading" v-show="isImageLoading"></span>
            <img
              v-if="qrCodeData.checkSize < 1"
              src="https://files.wondercv.com/auth/qrcode_reload.png"
              alt=""
              class="qrCodeReload pa cursor_p"
              @click="account_type === 'hr_account' ? getQrcode() : getMicroQrCode()"
            />
          </div>
          <div class="tips text_center f_14 color_40">
            <span v-if="account_type === 'hr_account'" class="iconfont icon-weixin pr"></span>
            <span v-if="account_type === 'hr_account'"> 扫码关注「超级招聘」快速登录</span>
            <template v-else>
              <span class="iconfont icon-weixin pr"></span>
              <span> 使用微信扫码登录</span>
            </template>
<!--            <span v-else>使用微信扫码登录</span>-->
<!--              <span class="highlight"><div class="code-box">-->
<!--              <div class="code-main">-->
<!--                <p>扫码下载 APP</p>-->
<!--                <img width="133" height="133" src="https://files.wondercv.com/pc/auth/auth-code.png"/>-->
<!--              </div>-->
<!--            </div></span>-->
<!--              微信扫码登录</span>-->
          </div>
        </div>
        <p class="protocol-tips text_center f_14 color_9c">登录即代表同意<a  href="/agreement" target="_blank">《服务协议》</a><a href="/privacy" target="_blank">《用户隐私条款》</a></p>

        <!-- 其他登录方式 -->
        <div class="otherSignin" v-if="signinType==='other'">
          <div class="title text_center f_16 color_40">选择你的登录方式</div>
          <div class="other flex">
            <div class="item flex1 text_center cursor_p transition_all2">
              <div class="icon transition_all2"><span class="iconfont icon-tubiao209 color_9c transition_all2"></span></div>
              <div class="name f_16 color_9c transition_all2">邮箱登录</div>
            </div>
            <div class="item flex1 text_center cursor_p transition_all2">
              <div class="icon transition_all2"> <span class="iconfont icon-lingying color_9c transition_all2"></span></div>
              <div class="name f_16 color_9c transition_all2">领英登录</div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <LoginDevice
            :equipment-list="loginDeviceList"
            :equipment-dialog="loginDeviceDialog"
            @delEquipmentFn="delLoginDevice"
            @cancelFn="loginDeviceDialog = false"
            @login="deviceDialogLogin"
    />
<!--    <BindPhone :state="bindPhoneState" @close="handleCancel" @success="handleSuccess" v-if="bindPhoneState" />-->
  </div>
</template>

<script>
// 所有接口
import { uuid } from 'vue-uuid';
import actions from '@/actions/index'
import { mapState, mapMutations } from 'vuex'
import * as utils from '@/utils/utils'
import {isRobot} from "../../utils/utils";
import LoginDevice from '@/components/loginDevice'
import { userMixin } from '@/assets/js/mixins'
import { ENV_VERSION } from '@/config/config'
export default {
  mixins: [userMixin],
  data(){
    return {
      swapper:['https://files.wondercv.com/auth_frontend/banner1.png','https://files.wondercv.com/auth_frontend/banner2.png','https://files.wondercv.com/auth_frontend/banner1.png','https://files.wondercv.com/auth_frontend/banner2.png'],
      account_type:'cv_account', //账户种类 hr_account 或 cv_account
      signinType:'wechat', // wechat微信，email邮箱，phone手机号，other其他
      signinTypes:{
        wechat: true,
        phone: true,
        // email: true,
        // other: true
      },
      signin_phone:require('@/assets/images/signin_phone.png'),
      signin_phone_current:require('@/assets/images/signin_phone_current.png'),
      signin_wechat:require('@/assets/images/signin_wechat.png'),
      signin_wechat_current:require('@/assets/images/signin_wechat_current.png'),
      codeData:{
        state:false,//是否正在获取验证码
        type:'phone', //当前获取类型
        time:60, //倒计时
      },
      phoneData:{
        phone:'',
        code:'',
      },
      errorData:{ //错误信息
        phone:'',
        code:'',
      },
      codeTimeoutName:null, //验证码定时器
      qrCodeQuery:{ // 获取二维码参数
        expire_seconds:60, //二维码有效期
        operation_type: 'login', //login/bind
        scene_str:'signin_' + uuid.v1(), //场景值 {扫码业务}+{身份} 扫码业务：login 扫码业务(string):login 例如login_动态的uuid
        account_type:'cv_account', //账户种类 hr_account 或 cv_account
      },
      qrCodeData:{ //二维码参数
        url:'',
        uuid: '',
        checkSize:57/3, // 轮训次数
      },
      qrCodeTimeoutName:null, // 微信登录轮训定时器
      isJbTemps:false,//是否是从 jb_temps 路由过来的
      isBindPhone:true, //是否绑定手机号
      isImageLoading:true,//图片显示时loading动画
      verify: {
        appId: process.env.VUE_APP_ENV_TYPE === 'prod' ? '2098377241' : '2059326702'
      },
      loginFlag: true,   // 扫码登录开关，谁先扫码验证成功登录的就是谁的账号
      bindPhoneState: false,
      new_account: false,  // 是否新账号
			loginDeviceDialog: false,
			jwtData: '',
			loginDeviceList: [],
      microSceneStr: '',
      microQrCode: '',
    }
  },
  components: {
    // BindPhone
		LoginDevice
  },
  async created(){
    //如果用户已登录，返回上一页/cvs
    let _t = utils.getCookie('_t');
    let { type='', account_type='',m_b='',m_t='error' } = this.$route.query;
    let _n_b_p = localStorage.getItem('_n_b_p') || ''; //localstorage中的值;
    if(_n_b_p==='true'){
      //未绑定手机号，直接删除jwt
      await utils.updateJWT({
        jwt:'',
        jwt_timestamp:parseInt(new Date().getTime()/1000)+1
      })
      localStorage.setItem('_n_b_p', false);
      _t = ''
    }
    try {
      //删除jwt
      await utils.updateJWT({
        jwt:'',
        jwt_timestamp:parseInt(new Date().getTime()/1000)-1
      })
    } catch (error) {}
    if(_t){
      // //如果有_t，先执行刷新接口确认是否正确，
      // let res = await actions.auth.refreshJwt({
      //   jwt:_t
      // });
      // if(res.code ===1000){
      //   let { jwt, jwt_timestamp } = res.data;
      //   await utils.updateJWT({
      //     jwt:jwt,
      //     jwt_timestamp:jwt_timestamp
      //   })
      //   this.pageJump(false);
      // }else{
      //   //删除jwt
      //   await utils.updateJWT({
      //     jwt:'',
      //     jwt_timestamp:parseInt(new Date().getTime()/1000)-1
      //   })
      // }
    }
    if(type && this.signinTypes[type]){
      this.signinType = type;
    }
    // 区分用户来源类型
    if(account_type && account_type==='hr_account'){
      this.qrCodeQuery.account_type = account_type;
      this.account_type = account_type;
    }
    // 如果类型是微信，自动获取二维码
    if(this.signinType === 'wechat'){
      this.account_type === 'hr_account' ? this.getQrcode() : this.getMicroQrCode()
    }
    // m_b //提示文案描述
    // m_t //提示文案类型 success，warning，error
    if(m_b){
      this.$message({
        message: m_b,
        type: m_t
      });
      let url = `${window.location.origin}/auth-signin?type=${type}&account_type=${account_type}`
      history.replaceState(null,null,url)
    }
    //是否是从 jb_temps 路由过来的
    let _r_b_t = utils.getCookie('_r_b_t');
    if(_r_b_t && _r_b_t.includes('jb_temps')){
      this.isJbTemps = true;
    }
    // 启动Udesk
    this.loadUdesk();
  },
  mounted () {
    if (window.TencentCaptcha === undefined) {
      let script = document.createElement('script');
      let head = document.getElementsByTagName('head')[0];
      script.type = "text/javascript";
      script.charset = "UTF-8";
      script.src = "https://turing.captcha.qcloud.com/TCaptcha.js";
      head.appendChild(script);
    }
  },
  methods: {
    ...mapMutations('block',['setAlertText']),
    // 跳过绑定手机号
    handleCancel() {
      this.bindPhoneState = false
      this.$message({
        message: '登录成功，页面正在跳转…',
        type: 'success',
        duration: 0
      });
      if(this.account_type === 'hr_account'){
        // 获取用户绑定信息，用作跳转
        this.getUsersBindInfo();
      }else{
        localStorage.setItem('_n_b_p', false);
        //【登录成功】读取跳转页面
        this.pageJump()
      }
    },
    // 绑定成功
    handleSuccess() {
      this.bindPhoneState = false
      this.$message({
        message: '登录成功，页面正在跳转…',
        type: 'success',
        duration: 0
      });
      if(this.account_type === 'hr_account'){
        // 获取用户绑定信息，用作跳转
        this.getUsersBindInfo(this.new_account);
      }else{
        localStorage.setItem('_n_b_p', false);
        //【登录成功】读取跳转页面
        this.pageJump(this.new_account)
      }
    },
    // 腾讯的人机验证
    tencentRobot() {
      let { phone } = this.phoneData;
      if(!phone){
        this.errorData.phone = '请输入手机号'
        return false;
      }else if(!(/^1[|3|4|5|6|7|8|9][0-9]\d{8,11}$/.test(phone)) || phone.length !== 11){
        this.errorData.phone = '请输入正确的手机号'
        return false;
      }
      if(this.codeData.state){
        return false;
      }

      isRobot(this.verify.appId, this.getCode)

    },
    toggleSigninType(type){
      //其他方式新窗口打开
      if(type === 'other'){
        window.open('/signin_email',null,null)
        return false;
      }
      this.signinType = type;
      // 清除 短信验证码及二维码 定时器
      // this.resetCodeData();
      if(type === 'wechat'){
        // 获取二维码
        this.account_type === 'hr_account' ? this.getQrcode() : this.getMicroQrCode()
      }
    },
    //【手机】获取短信验证码-检测+启动极验
    checkPhoneCode(){
      let { phone } = this.phoneData;
      if(!phone){
        this.errorData.phone = '请输入手机号'
        // this.$message({
        //   message: '请输入手机号',
        //   type: 'warning'
        // });
        return false;
      }else if(!(/^1[|3|4|5|6|7|8|9][0-9]\d{8,11}$/.test(phone)) || phone.length !== 11){
        this.errorData.phone = '请输入正确的手机号'
        // this.$message({
        //   message: '请输入正确的手机号',
        //   type: 'warning'
        // });
        return false;
      }
      if(this.codeData.state){
        return false;
      }
      //获取验证码
      this.getCode();

    },
    // 【手机】获取短信验证码-接口
    getCode(randstr, ticket){
      let { phone } = this.phoneData;
      this.codeData.state = true;
      let data = {
        // ...this.gt,
        premise: 'without',
        phone_number:phone,
        new_code: true

      }
      if (randstr && ticket) {
        Object.assign(data, {captcha_rand_str: randstr, captcha_ticket: ticket})
      }
      actions.auth.getPhoneCode(data).then(res=>{
        if(res.code === 1000){
          this.$message({
            message: '验证码已发送，请注意查收',
            type: 'success'
          });
          this.codeData.time = 59;
          this.codeTime();
        }else{
          this.codeData.state = false;
          this.$message({
            message: res.message,
            type: 'error'
          });
        }
      })
    },
    //【验证码】倒计时
    codeTime(){
      this.codeTimeoutName = setInterval(() => {
        if(this.codeData.time == 1){
          clearInterval(this.codeTimeoutName);
          this.codeData.state = false;
          this.codeData.time = 60;
          return false;
        }
        this.codeData.time = this.codeData.time-1;
      }, 1000);
    },
    //【验证码】重置
    resetCodeData(){
      clearInterval(this.codeTimeoutName);
      this.codeData.state = false;
      this.codeData.time = 60;
    },
    // 邮箱/手机登录
    signin(){
      if(this.signinType === 'phone'){
        let { phone, code } = this.phoneData;
        if(!phone){
          this.errorData.phone = '请输入手机号'
          // this.$message({
          //   message: '请输入手机号',
          //   type: 'warning'
          // });
          return false;
        }else if(!(/^1[|3|4|5|6|7|8|9][0-9]\d{8,11}$/.test(phone)) || phone.length !== 11){
          this.errorData.phone = '请输入正确的手机号'
          // this.$message({
          //   message: '请输入正确的手机号',
          //   type: 'warning'
          // });
          return false;
        }
        if(!code || code.length!==6){
          this.errorData.code = '请输入正确的验证码'
          // this.$message({
          //   message: '请输入正确的手机验证码',
          //   type: 'warning'
          // });
          return false;
        }
        let data = {
          phone_number:phone,
          phone_code:code,
          source:'pc_browser',
          // role:  this.account_type ==='cv_account' ? 'cv' : 'hr'
        }
        actions.auth.userLogin_or_sigup({account_type:this.account_type, data}).then(async res=>{
          if(res.code===1000){
						let { new_account, jwt, jwt_timestamp } = res.data;
						window.sessionStorage.setItem('_t', res.data.jwt)
            this.jwtData = res.data
						this.addLoginDevice(res.data)
          }else{
            this.$message.error(res.message);
          }
        })
      }
    },
		// 添加登录设备
		async addLoginDevice(jwtData, is_wechat=false) {
			try {
				const data = {
					device_name: (navigator.appName + navigator.platform + navigator.product + '').replace(/\//g,"") + this.getEquipmentNumberFn(),
					device_number: (navigator.appName + navigator.platform + navigator.product + navigator.userAgent).replace(/\//g,"") + this.getEquipmentNumberFn()
				}
				let jwt = jwtData.jwt
				const res = await actions.auth.addLoginDevice({data, jwt})
				console.log(res, "==================>ressss")
				if (res.code === 1000) {

					this.$message({
						message: '登录成功，页面正在跳转…',
						type: 'success',
						duration: 0
					});
					this.loginFlag = false;
					//清除倒计时状态
					this.resetCodeData();
					// 插入jwt 的登录状态
					await utils.updateJWT({
						jwt,
						jwt_timestamp: jwtData.jwt_timestamp
					})
					localStorage.setItem('_n_b_p', false);
          window.sessionStorage.removeItem('_t')
          window.sessionStorage.removeItem('_t_d')
					if (is_wechat){
						try {
							// 存储标记时间戳
							localStorage.setItem('cvsBindPhone', Math.floor(new Date().getTime() / 1000));
							if(this.account_type === 'cv_account') {
								//执行跳转
								this.pageJump(jwtData.new_account);
								//   let res = await actions.auth.getBindMessage(this.cvAccountToken);
								//   if(res.code === 1000){
								//     //同步是否绑定手机号
								//     this.isBindPhone = res.data.phone_is_bound;
								//     if(this.isBindPhone){
								//       localStorage.setItem('_n_b_p', false);
								//       //执行跳转
								//       this.pageJump(new_account);
								//     }else{
								//       localStorage.setItem('_n_b_p', true);
								//       if (res.data.active_cv_count > 0) {
								//         this.bindPhoneState = true
								//       } else {
								//         this.pageJump(new_account);
								//       }
								//     }
								//   }
							} else {
								// b端账号直接跳转
								// this.pageJump(new_account);
								this.getUsersBindInfo(jwtData.new_account)
							}
						} catch (e) {
							console.error(e)
						}
          }
					// 新用户，上报注册来源
					if(jwtData.new_account){
						try {
							await this.reportLoginCookies();
						} catch (error) {}
					}
					//【登录成功】读取跳转页面
          if (!is_wechat){
						this.pageJump(jwtData.new_account)
          }

				} else {
					this.getLoginDeviceList(jwtData)
					this.loginDeviceDialog = true
					clearInterval(this.qrCodeTimeoutName);
					this.qrCodeTimeoutName = null
				}
			} catch (e) {
				console.log('add login device error', e)
			}
		},
		// 删除登录设备
		async delLoginDevice(list) {
			try {
				let jwt = this.jwtData.jwt
				const res = await actions.auth.delLoginDevice({device_numbers: list}, jwt)
				if (res.code === 1000) {
					this.$message.success('删除成功')
					this.getLoginDeviceList(this.jwtData)
				} else {
					this.$message.error(res.message)
				}
			} catch (e) {
				console.log('del login device error', e)
			}
		},
		// 生成浏览器登录指纹
		getEquipmentNumberFn() {

			function bin2hex(s) {
				var i,l,o = "",n;s += "";
				for (i = 0, l = s.length; i < l; i++) {
					n = s.charCodeAt(i).toString(16);
					o += n.length < 2 ? "0" + n : n;
				}
				return o;
			}
			function getUUID(domain) {
				var canvas = document.createElement("canvas");
				var ctx = canvas.getContext("2d");
				var txt = domain;
				ctx.textBaseline = "top";
				ctx.font = "14px 'Arial'";
				ctx.textBaseline = "tencent";
				ctx.fillStyle = "#f60";
				ctx.fillRect(125, 1, 62, 20);
				ctx.fillStyle = "#069";
				ctx.fillText(txt, 2, 15);
				ctx.fillStyle = "rgba(102, 204, 0, 0.7)";
				ctx.fillText(txt, 4, 17);

				var b64 = canvas.toDataURL().replace("data:image/png;base64,", "");
				// window.atob 用于解码使用 base-64 编码的字符串
				var bin = atob(b64);
				var crc = bin2hex(bin.slice(-16, -12));
				return crc;
			}
			return getUUID("wondercv")
		},
		// 删除设备之后登录
		async deviceDialogLogin() {
			try {
				this.addLoginDevice(this.jwtData)
			} catch (e) {
				console.log('device login error', e)
			}
		},
		// 获取登录设备列表
		async getLoginDeviceList(jwtData) {
			try {
				const params = {
					page: 1,
					page_size: 100
				}
				let jwt = jwtData.jwt
				const res = await actions.auth.getDeviceList({params, jwt})
				console.log(res, "================>ress list")
				if (res.code === 1000) {
					this.loginDeviceList = res.data.devices
				}
			} catch (e) {
				console.log('get login device list error', e)
			}
		},
    //【微信】获取二维码
    getQrcode(){
      //轮训倒计时
      this.qrCodeData = { //二维码参数
        url:'',
        uuid: '',
        checkSize:57/3, // 轮训次数
      }
      //清除定时器
      clearInterval(this.qrCodeTimeoutName);
      this.isImageLoading = true
      //获取二维码接口
      actions.auth.getWechatQrCode(this.qrCodeQuery).then(res=>{
        if(res.code === 1000){
          this.qrCodeData.url = res.data.url;
          this.qrCodeData.uuid= res.data.qr_url.split('/').pop()
          this.getUniCode()
          //轮训倒计时
          this.qrCodeData.checkSize = 57/3;
          // 【微信/自定义扫码登录】检测是否登录
          this.checkWechatLogin();

          // 如果是edge浏览器，直接显示二维码
          try{
            let UA = navigator.userAgent || 'Edge';
            UA = UA.toLowerCase()
            if(UA.indexOf('edg') >-1){
              setTimeout(() => {
                this.isImageLoading=false
              }, 500);
            }
          }catch(error){
            this.isImageLoading=false
          }

        }else{
          this.$message.error(res.message);
        }
      })

    },
    generateUUID8() {
      return 'xxxxxxxx'.replace(/x/g, () => {
        return Math.floor(Math.random() * 16).toString(16);
      });
    },
    // 获取小程序登录码
    async getMicroQrCode() {
      try {
        this.microQrCode = ''
        this.microSceneStr = ''
        this.qrCodeData.checkSize = 57/3

        clearInterval(this.qrCodeTimeoutName)
        this.isImageLoading = true
        const scene_str = `login_${this.generateUUID8()}`
        this.microSceneStr = scene_str
        const { data, code, message } = await actions.auth.getMicroQrCode({
          ...this.qrCodeQuery,
          account_type: "wechat_miniprogram",
          scene_str,
          env_version: ENV_VERSION
        })
        if (code !== 1000) {
          return this.$message.error(message);
        }
        this.microQrCode = `data:image/png;base64,${data.body}`;
        this.checkWechatLogin()
      } catch (error) {
        this.isImageLoading = false
        console.log(error, 'getMicroQrCode error')
      }
    },
    // 验证登录状态
    verifyLogin () {
      let params = {
        uuid: this.qrCodeData.uuid
      }
      actions.auth.verifyLoginStatus(params).then(res=>{
        if (res.code === 1000) {
          if (res.data && res.data.jwt && res.data.jwt !== 'unlogin') {
            if (this.loginFlag) {
              clearInterval(this.qrCodeTimeoutName);
              this.loginFlag = false;
							this.jwtData = res.data
              utils.updateJWT({
                jwt: res.data.jwt,
                jwt_timestamp: Math.floor(new Date().getTime() / 1000) + 14 * 24 * 60 * 60
              })
              setTimeout(() => {
                localStorage.setItem('_n_b_p', false);
                this.pageJump()
              }, 1000)
            }
          }
        } else {
          this.$message.error(res.message)
        }
      })
    },
    /***
     * 请求生成唯一标识
     * nums: 轮训次数
     * ***/
    getUniCode (nums) {
      // 请求失败5次不再进行请求
      if (nums && nums === 4) {
        return
      }
      let params = {
        uuid: this.qrCodeData.uuid
      }
      actions.auth.getAppQrcode(params).then(res=>{
        if(res.code === 1000){

        }else{
          // 请求失败再次进行请求并把请求数 +1
          if (nums) {
            this.getUniCode(nums++)
          } else {
            this.getUniCode(1);
          }
          this.$message.error(res.message)
        }
      })
    },
    // 获取小程序扫码结果
    async getWechatScanResult() {
      try {
        const res = await actions.auth.getWechatScanResult({
          scene_str: this.microSceneStr,
          operation_type: 'login',
          account_type: 'wechat_miniprogram'
        })
        if(res.code === 1000 && res.data.jwt) {
          if (this.loginFlag) {
						this.loginFlag = false
						let { new_account } = res.data;
						clearInterval(this.qrCodeTimeoutName);
						this.new_account = new_account;
						this.jwtData = res.data
						window.sessionStorage.setItem('_t', res.data.jwt)
						this.addLoginDevice(res.data, true)
					}
        }
      } catch (error) {
        console.log(error, 'getWechatScanResult error')
      }
    },  
    //【微信/自定义扫码登录】检测是否登录
    checkWechatLogin(){
      this.qrCodeTimeoutName = setInterval(() => {
        this.verifyLogin()
        this.resultWechat();
        this.getWechatScanResult()
        this.qrCodeData.checkSize = this.qrCodeData.checkSize-1;
        if(this.qrCodeData.checkSize<1){
          clearInterval(this.qrCodeTimeoutName);
        }
      }, 3000);
    },
    //【微信】验证是否登录
    resultWechat(){
      let query = {
        scene_str: this.qrCodeQuery.scene_str,
        operation_type: 'login'
      }
      actions.auth.result_wechat({account_type:this.account_type, params: query }).then(async res=>{
        if(res.code === 1000){
          if (this.loginFlag) {
						this.loginFlag = false
						let {jwt, jwt_timestamp, new_account} = res.data;
						clearInterval(this.qrCodeTimeoutName);
						this.new_account = new_account;
						this.jwtData = res.data
						window.sessionStorage.setItem('_t', res.data.jwt)
						this.addLoginDevice(res.data, true)

					}
        }

      })
    },
    //【登录成功】读取跳转页面
    pageJump(new_account){
      // if(new_account){
      //   //新用户跳转到cvs，然后自动会跳转到 选择身份页面
      //   window.location.href = window.location.origin+'/select_identity'
      // }else{
        let r_b_t = utils.getCookie('_r_b_t') || '';
        // 返回的url中必须有 wondercv
        if(!r_b_t.includes('wondercv')){
          r_b_t = '';
        }
        // 返回的url要进行解码再跳转
        if(r_b_t){
          r_b_t = decodeURIComponent(r_b_t);
        }
        let _t = utils.get_tUser();
        if(this.account_type==='hr_account'){
          if(!r_b_t.includes('/talent/')){
            r_b_t = '';
          }
          let hr_url = window.location.origin + `${this.isBindPhone? '/talent/userinfo':'/talent/binduser'}`
          let hr_indexUrl = window.location.origin + '/talent/search'
          //如果返回的url中包含 用户信息的url
          let link_to = r_b_t.includes(`${hr_url}`)? ( r_b_t.includes('?')?r_b_t+'&showJump=true':r_b_t+'?showJump=true' ) : `${hr_url}${r_b_t ? '?link_to='+encodeURIComponent(r_b_t)+'&showJump=true' : '?showJump=true'}`;
          // 新用户，完善hr信息
          if(new_account){
            window.location.href = window.location.origin + '/talent/binduser'
          }else{
            // hr登录之后的判断, 是否是hr，判断是否绑定手机号 判断是否读取本地地址
            window.location.href = _t.h_t ? ( this.isBindPhone ? ( r_b_t || hr_indexUrl) : link_to ) : link_to ;
          }
          utils.delCookie('_r_b_t');
        }else{
          // cv登录之后的判断
          if(r_b_t.includes('/talent/')){
            r_b_t = '';
          }
          // 不是新用户 && 有 r_b_t
          if(r_b_t && !new_account){
            // let useTemplate = localStorage.getItem('useTemplate');
            // if (useTemplate) {
            //   localStorage.removeItem('useTemplate');
            //   window.location.href = `${window.location.origin}/cvs/${useTemplate}/editor`
            //   utils.delCookie('_r_b_t');
            //   return
            // }
            window.location.href = r_b_t;
            utils.delCookie('_r_b_t');
          }else{
            if (new_account) {
              localStorage.setItem('newAccount', 'true')
            }
            //新用户跳转到cvs，然后自动会跳转到 选择身份页面
            window.location.href = window.location.origin+'/cvs'
          }
        }
      // }
    },
    toggerUserType(account_type){
      if(this.account_type === account_type){
        return false;
      }
      this.isImageLoading = true;
      if(this.signinType==='wechat' && account_type === 'hr_account'){
        this.getQrcode();
      } else if (this.signinType === 'wechat' && account_type === 'cv_account') {
        this.getMicroQrCode()
      }
      this.account_type = account_type
      this.qrCodeQuery.account_type = account_type
    },
    // 错误信息
    errorMessage(){
      let udesk_container = document.querySelector('#udesk_btn a');
      if(udesk_container!=null){
        udesk_container.click();
      }
    },

    // Udesk 启动客服
    async loadUdesk(){
      // let { public_key, private_key} = this.userData;
      // let params = await actions.udesk.dealSignatrue({public_key},private_key);
      actions.udesk.udeskOnlineUrl({}).then(res=>{
        if(res.code === 1000){
          let udeskArray = Object.assign(res.data.arr1, res.data.arr2);
          console.log('loadUdesk data =>',udeskArray)
          //定时器启动
          setTimeout(() => {
            (function(a,h,c,b,f,g){
              a["UdeskApiObject"]=f;
              a[f] = a[f] || function(){(
                a[f].d=a[f].d||[]
                ).push(arguments)
              };
              g = h.createElement(c);
              g.async=1;
              g.charset="utf-8";
              g.src=b;
              c=h.getElementsByTagName(c)[0];
              c.parentNode.insertBefore(g,c)
            })(window,document,"script","//assets-cli.udesk.cn/im_client/js/udeskApi.js","ud");
            //传递信息
            ud(udeskArray);
          }, 1000);
        }
      });

    },
    //取消错误提示
    inputFocus(type){
      this.errorData[type] = ''
    },
    //获取用户绑定信息
    async getUsersBindInfo(new_account){
      let user_token = utils.get_tUser().t || '';
      if(!user_token){
        localStorage.setItem('_n_b_p', true);
        //执行跳转
        this.pageJump(new_account);
        return
      }
      let res = await actions.auth.get_users_bind_info(user_token);
      if(res.code === 1000){
        //同步是否绑定手机号
        this.isBindPhone = res.data.phone_is_bound;
        localStorage.setItem('_n_b_p', !this.isBindPhone);
        //执行跳转
        this.pageJump(new_account);
      }
    },
    // 上报注册信息
    reportLoginCookies(){
      return new Promise(async (resolve, reject)=>{
        try {
          let accountToken = utils.get_tUser();
          let cookiesObj = utils.getCookie();
          let reportData = {
            data: {},
            cv_account_token: accountToken.c_t,
            hr_account_token: accountToken.h_t,
            data_type: "sem"
          }
          if(cookiesObj.sem_url){
            Object.keys(cookiesObj).forEach(key=>{
              if(key.indexOf('sem_') === 0){
                reportData.data[key] = cookiesObj[key]
              }
            })
            await actions.io.reporteSemdData(reportData)
          }
          resolve({})

          // console.log('cookiesObj=>>', cookiesObj)
          // console.log('reportData=>>', reportData)
        } catch (error) {
          resolve({})
        }
      })
    },
  }
}
</script>

<style lang="scss" scoped>
  @import './Index.scss';
  .el-icon-loading{
    position: absolute;
    font-size: 32px;
    color: #BCBCBC;
    top: calc(50% - 16px);
    left: calc(50% - 16px);
  }
  .highlight{
    color: #FF6644;
    cursor: pointer;
    position: relative;
    .code-box{
      position: absolute;
      width: 196px;
      height: 205px;
      display: none;
      right: -206px;
      bottom: -68px;
      background: url("https://files.wondercv.com/pc/auth/code-background.png") no-repeat;
      background-size: 100% 100%;
      .code-main{
        width: 187px;
        margin-left: 9px;
        display: flex;
        align-items: center;
        flex-direction: column;
        justify-content: center;
        padding-top: 17px;
        box-sizing: border-box;
        padding-bottom: 22px;
        box-shadow: -1px 6px 24px 0px rgba(0, 0, 0, 0.06);
        &>p{
          font-size: 14px;
          font-weight: 400;
          color: #404040;
          line-height: 14px;
          margin-bottom: 19px;
        }
      }

    }
    &:hover .code-box{
      display: block;
    }
  }
</style>
